export const getFiltersFromLocalStorage = (filterName) => {
  const filters = localStorage.getItem(filterName);
  return filters ? JSON.parse(filters) : null;
};

export const setFiltersToLocalStorage = (filterName, filters) => {
  localStorage.setItem(filterName, JSON.stringify(filters));
};

export const removeFiltersFromLocalStorage = (filterName) => {
  localStorage.removeItem(filterName);
};

export const generateFilterName = ({ entity, id }) => {
  return `eg-table-filters-${entity}-${id}`;
};
